<template>
    <section class="product-header">
        <div class="container">
            <div class="product-header__block">
                <div class="product-header__title">
                    <h2 class="title _title">Умный дом от Rolatex</h2>
                    <h3 class="_subtitle">Автоматизируй свой комфорт</h3>
                    <button class="btn _primary _big" type="button" @click="openForm"><span>Рассчитать стоимость</span> <span class="_d-none">умного дома</span></button>
                    <div class="product-header__present">
                        <span class="_icon"><img class="_img" src="/assets/img/automatize/icons/present.svg" alt=""></span>
                        <span class="_text">Получите в подарок 3D-визуализацию вашего проекта</span>
                    </div>
                </div>
                <div class="product-header__img">
                    <img src="/assets/img/automatize/about.png" alt="">
                    <div class="_item _item-1">
                        <span><img src="/assets/img/automatize/icons/header-photo-1.svg" alt=""></span>
                        <span class="_item__text">Энергосбережение</span>
                    </div>
                    <div class="_item _item-2">
                        <span><img src="/assets/img/automatize/icons/header-photo-2.svg" alt=""></span>
                        <span class="_item__text">Безопасноть</span>
                    </div>
                    <div class="_item _item-3">
                        <span><img src="/assets/img/automatize/icons/header-photo-3.svg" alt=""></span>
                        <span class="_item__text">Освещение</span>
                    </div>
                </div>
                <div class="product-header__steps">
                    <div class="steps-item">
                        <span class="_number">1</span>
                        <span class="_icon">
                            <img src="/assets/img/automatize/icons/steps-1.svg" alt="">
                        </span>
                        <span class="_text">Оставьте заявку на просчет своего проекта</span>
                    </div>
                    <div class="steps-item">
                        <span class="_number">2</span>
                        <span class="_icon">
                            <img src="/assets/img/automatize/icons/steps-2.svg" alt="">
                        </span>
                        <span class="_text">Получите в подарок 3D-визуализацию</span>
                    </div>
                    <div class="steps-item">
                        <span class="_number">3</span>
                        <span class="_icon">
                            <img src="/assets/img/automatize/icons/steps-3.svg" alt="">
                        </span>
                        <span class="_text">Наблюдайте, как ваш дом автоматизируется на глазах</span>
                    </div>
                </div>
            </div>
            <div class="arrow-down">
                <a href="#about" class="go">
                    <img src="/assets/img/automatize/icons/arrow-down.svg" alt="">
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import calculateSmartHousePrice from "./modals/calculateSmartHousePrice";

export default {
    name: 'smartHome',
    components: {calculateSmartHousePrice},
    methods: {
        openForm() {
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setCalculateSmartHousePriceStatus', true);
            document.body.classList.add('_no-scroll');
        }
    },
}
</script>
